<template>
    <b-button-group size="sm" class="btn-block">
        <b-button
            :pressed="validationFilter === 'valid'"
            variant="outline-success"
            @click="updateValidationFilter('valid')"
        >
            Validés
        </b-button>
        <b-button
            :pressed="validationFilter === 'invalid'"
            variant="outline-warning"
            @click="updateValidationFilter('invalid')"
        >
            Non validés
        </b-button>
        <b-button
            :pressed="validationFilter === 'all'"
            variant="outline-secondary"
            @click="updateValidationFilter('all')"
        >
            Tous
        </b-button>
    </b-button-group>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'ClientValidationFilter',

    methods: {
        updateValidationFilter(value) {
            this.$store.commit('browsing/SET_CLIENT_VALIDATION_FILTER', value)
            this.$emit('validation-filter-has-changed')
            this.$root.$refs.clientsTable.filterItems()
        },
    },

    computed: {
        ...mapState({
            validationFilter: (state) => state.browsing.clientsValidationFilter,
            activePage: (state) => state.browsing.pageName,
        }),
    },
}
</script>

<style scoped></style>
